import { debounce } from '@cian/ui-kit/internal/utils';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ERuntimeSettings } from '../../../common/types/runtimeSettings';
import { dispatchCustomEvent } from '../../../common/utils';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { selectCalculatorValues } from '../../selectors/selectCalculatorValues';
import { ICalculatorState } from '../../types/calculator';

//TODO написать тест на корректность функции
/* istanbul ignore next */
export function useEventOnCalculateSubsidizedMortgage(eventRef: React.RefObject<HTMLElement | null>) {
  const calculatorValues = useSelector(selectCalculatorValues);
  const context = useApplicationContext();
  const eventName = context.config.getStrict<string>(ERuntimeSettings.subsidizedCalculatorEventName);
  const debouncedEvent = useMemo(() => debounce(dispatchCustomEvent<ICalculatorState, 'calculatorValues'>, 300), []);

  useEffect(() => {
    const onChangeHandler = () => {
      if (eventRef?.current) {
        debouncedEvent(eventRef.current, eventName, {
          description: 'Данные из микрофронта калькулятора SubsidizedMortgage',
          calculatorValues,
        });
      }
    };
    onChangeHandler();
  }, [calculatorValues, eventName, eventRef, debouncedEvent]);
}
